import { useState, type ReactNode } from "react";
import { PaymentDialog } from "./PaymentDialog";

export function CheckoutButton({ doramaId, price = 27, className, children }: {
  doramaId?: string; price?: number | null; className?: string; children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  return <>
    <button type="button" className={className} onClick={() => setOpen(true)}>{children}</button>
    {open && <PaymentDialog doramaId={doramaId} price={price} onClose={() => setOpen(false)} />}
  </>;
}